import { formatMoney, formatMoneyTrimmed } from 'lib/utils';
import { formatDate } from 'lib/utils/customDate';
import { Currency } from 'lib/type/enums';
import { TransactionListItem } from 'lib/type';
import clsx from 'clsx';
import useTranslate from 'lib/languages/useTranslate';

interface TransactionCardProps {
    item: TransactionListItem;
    keyIndex: string;
}

const TransactionCard = ({
    item: {
        createdDate,
        recipient,
        reference,
        value,
        currency = Currency.GBP,
        statusCode,
    },
    keyIndex,
}: TransactionCardProps) => {
    const translate = useTranslate('transaction');

    const amountFormatted = `${value > 0 ? '+' : ''}${formatMoney(
        value,
    )} ${currency}`;

    const declineAmount = `${formatMoneyTrimmed(value).replace(
        '-',
        '',
    )} ${currency}`;

    return (
        <div className="transaction-container">
            <input
                id={`collapsible-${keyIndex}`}
                className="toggle"
                type="checkbox"
            />
            <div className="transaction-toggle">
                <div className="transaction-left">
                    <p className="transaction-name">
                        {recipient || reference}
                    </p>
                </div>
                <div className="transaction-right">
                    <div className="transaction-item-container">
                        <p className="transaction-type"></p>
                    </div>
                    <div className="transaction-item-container">
                        <p
                            className={clsx('transaction-amount', {
                                red: statusCode === 'I',
                                green: value > 0,
                            })}
                        >
                            {amountFormatted}
                        </p>
                        {statusCode === 'I' && (
                            <p className="transaction-decline-status-text">
                                {translate('declined')}
                            </p>
                        )}
                    </div>
                </div>
            </div>
            <div className="collapsible-content">
                <div className="content-inner">
                    <p>
                        {translate('date')} -{' '}
                        <strong>{formatDate(createdDate)}</strong>
                    </p>
                    {!!reference && (
                        <p>
                            {translate('reference')} -{' '}
                            <strong>{reference}</strong>
                        </p>
                    )}
                    {statusCode === 'I' && (
                        <p className="transaction-decline-status-text">
                            {translate('declinedMessage', { declineAmount })}
                        </p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default TransactionCard;
